import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import BatteryForm from './BatteryForm'
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/batteryActions";
import History from "../../../History";
const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const BatteryCreate = props => {
    const { permissions, activeCustomer, translations, classes } = props;
    let searchParams = parseURL(window.location.search);
    const handleSubmit = async data => {
        data['ProductID'] = searchParams.productID;
        let result = await props.onCreateBattery({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ComponentType: "battery",
        Vendor: "",
        ComponentModel: '',
        SerialNumber: '',
        BatteryHealth: '',
        BatteryCycleCount: 0,
        BatteryDesignCapacity: 0,
        BatteryFullChargeCapacity: 0,
        Description: ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            BatteryHealth: Yup.string().required("Required"),
            BatteryCycleCount: Yup.number().required("Required"),
            BatteryDesignCapacity: Yup.number().required("Required"),
            BatteryFullChargeCapacity: Yup.number().required("Required"),
        },
        FormTitle: translations['create_battery_component'] || "Create battery component",
        ButtonSubmit: hasPermission(permissions, "component_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}             >
            {BackButton(translations)}

            <BatteryForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            ></BatteryForm>
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateBattery: battery => dispatch(actions.createBattery(battery)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(BatteryCreate));
